import moment from 'moment/moment'
import { EMPTY_FIELD, FORMAT_DATE_INVALID, FORMAT_HOUR_MINUTE_INVALID } from './constants'

export default function dateValidateWithFormat(format) {
  return function(dateAsString) {
    if (!dateAsString) return EMPTY_FIELD

    return moment(dateAsString, format, true).isValid() === false
      ? format === 'HH:mm' ? FORMAT_HOUR_MINUTE_INVALID : FORMAT_DATE_INVALID
      : undefined
    // }
    // return undefined
  }
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dateValidateWithFormat.js